import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import PageHero from '../../components/feature/PageHero';

const WHATSAPP_URL = 'https://wa.me/5511989036294?text=Ol%C3%A1%2C%20preciso%20de%20atendimento%20jur%C3%ADdico%20urgente.';

export default function SobrePage() {
  return (
    <main className="font-sans">
      <Header />
      <PageHero
        tag="O escritório"
        titulo="Moreira"
        tituloItalico="Tófoli Advogados"
        subtitulo="Assessoria jurídica completa para pessoas e empresas, com rigor técnico e dedicação total a cada caso."
      />

      {/* Valores e diferenciais */}
      <section className="py-[60px] bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="grid lg:grid-cols-3 gap-10">
            <div className="border-t-2 border-[#B39B62] pt-8">
              <div className="w-10 h-10 flex items-center justify-center mb-5">
                <i className="ri-scales-3-line text-[#B39B62] text-2xl"></i>
              </div>
              <h3 className="font-serif text-xl text-[#0A1829] font-medium mb-3">Rigor Técnico</h3>
              <p className="font-sans text-[#0A1829]/60 text-sm leading-relaxed">
                Cada caso é analisado com profundidade, levantando todos os aspectos jurídicos e construindo estratégias sólidas baseadas em conhecimento e experiência.
              </p>
            </div>
            <div className="border-t-2 border-[#B39B62] pt-8">
              <div className="w-10 h-10 flex items-center justify-center mb-5">
                <i className="ri-user-heart-line text-[#B39B62] text-2xl"></i>
              </div>
              <h3 className="font-serif text-xl text-[#0A1829] font-medium mb-3">Cuidado Humano</h3>
              <p className="font-sans text-[#0A1829]/60 text-sm leading-relaxed">
                Além da técnica, entendemos o impacto humano de cada situação. Tratamos cada cliente com empatia, transparência e respeito absoluto.
              </p>
            </div>
            <div className="border-t-2 border-[#B39B62] pt-8">
              <div className="w-10 h-10 flex items-center justify-center mb-5">
                <i className="ri-shield-check-line text-[#B39B62] text-2xl"></i>
              </div>
              <h3 className="font-serif text-xl text-[#0A1829] font-medium mb-3">Comprometimento</h3>
              <p className="font-sans text-[#0A1829]/60 text-sm leading-relaxed">
                Assumimos o compromisso com o resultado de cada caso. Do primeiro contato ao desfecho, estamos presentes e dedicados em cada etapa do processo.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section className="py-[60px] bg-[#0A1829] text-center">
        <div className="max-w-2xl mx-auto px-6">
          <div className="flex items-center justify-center gap-3 mb-5">
            <span className="h-px w-10 bg-[#B39B62]"></span>
            <span className="text-[#B39B62] text-xs font-sans font-semibold tracking-[0.2em] uppercase">
              Vamos conversar
            </span>
            <span className="h-px w-10 bg-[#B39B62]"></span>
          </div>
          <h2 className="font-serif text-3xl lg:text-4xl text-white font-light mb-4">
            Pronto para contar com{' '}
            <span className="italic text-[#E9D59C]">nossa assessoria jurídica?</span>
          </h2>
          <p className="font-sans text-white/55 text-base leading-relaxed mb-8">
            Atendimento jurídico completo para pessoas e empresas. Entre em contato agora.
          </p>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-[#B39B62] hover:bg-[#E9D59C] text-[#0A1829] font-sans font-semibold text-base px-10 py-4 rounded-md transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            Falar com advogado
          </a>
        </div>
      </section>

      <Footer />
    </main>
  );
}
